const isDevEnvironment = process.env.NEXT_PUBLIC_ENVIRONMENT === 'local';

export default isDevEnvironment;
